import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import Cookies from 'js-cookie';
import Const from './const';
/**
 * Cookie数据结构
 * Cookie = {
    key: string, //cookie的key值
    value: string, //cookie对应该key的value值
    domain:string, //cookie的Domain值
    path:string, //cookie的Path值
    expires:string, //cookie的Expires值
    secure:string, //是否使用secure的bool值
    httpOnly:string, //是否httpOnly的bool值
}
 */

var handleDomain = function handleDomain(cookie, url) {
  return cookie;
};

var CookieManager = {};

CookieManager.getCookieForKey = function (key, url, callback, errorCallback) {
  var _key = "".concat(Const.prefixCookie).concat(key).concat(url);

  var _cookie = '';

  try {
    _cookie = Cookies.get(_key);
  } catch (error) {
    errorCallback(error);
    return;
  }

  var retCookie = handleDomain(_cookie, url);
  callback && callback(retCookie ? JSON.parse(retCookie) : '');
};

CookieManager.setCookie = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookie, callback) {
    var _key, _data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _key = "".concat(Const.prefixCookie).concat(cookie.key).concat(cookie.domain);
            _data = JSON.stringify(cookie);
            _context.prev = 2;
            _context.next = 5;
            return Cookies.set(_key, _data);

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            throw new Error('Set Cookie failed');

          case 10:
            callback && callback();

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

CookieManager.removeCookieForKey = function (key, url, callback) {
  CookieManager.getCookieForKey(key, url, function (retCookie) {
    if (retCookie) {
      Cookies.remove("".concat(Const.prefixCookie).concat(retCookie.key).concat(retCookie.domain), function (res) {
        callback(null, res);
      });
    } else {
      callback('the cookie is not exist');
    }
  });
};

CookieManager.removeCookie = function (cookie, callback) {
  CookieManager.getCookieForKey(cookie.key, cookie.domain, function (retCookie) {
    if (retCookie && retCookie.path === cookie.path) {
      Cookies.remove("".concat(Const.prefixCookie).concat(retCookie.key).concat(retCookie.domain), function (res) {
        callback(null, res);
      });
    } else {
      callback('the cookie is not exist');
    }
  });
};

export default CookieManager;